import React from 'react'
import { SiteNavigationHeader } from './SiteNavigationHeader'
import { SiteImageViewer } from './SiteImageViewer'
import { DiveSiteMap } from './DiveSiteMap'

export function MapTab({
  currentSite,
  currentSiteImages,
  currentImage,
  currentSiteIndex,
  siteNames,
  onPrevSite,
  onNextSite,
  onPrevImage,
  onNextImage,
  onImageClick,
  onSiteSelect,
}) {
  return (
    <div className="map-tab">
      <SiteNavigationHeader
        siteName={currentSite}
        onPrevSite={onPrevSite}
        onNextSite={onNextSite}
        totalSites={siteNames.length}
        currentIndex={currentSiteIndex}
      />
      
      <div className="map-tab__content">
        <SiteImageViewer
          image={currentImage}
          images={currentSiteImages}
          onPrevImage={onPrevImage}
          onNextImage={onNextImage}
          onImageClick={onImageClick}
        />
        
        <DiveSiteMap
          currentSite={currentSite}
          siteNames={siteNames}
          onSiteSelect={onSiteSelect}
        />
      </div>
    </div>
  )
}

